'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const ImpactSection = () => {
  const impactStats = [
    {
      icon: 'UsersIcon',
      value: '127,450',
      label: 'Lives Impacted',
      description: 'Individuals directly supported through donations'
    },
    {
      icon: 'CurrencyDollarIcon',
      value: '$2.4M',
      label: 'Total Raised',
      description: 'Funds collected for humanitarian programs'
    },
    {
      icon: 'GlobeAltIcon',
      value: '45',
      label: 'Countries Reached',
      description: 'Nations where we provide support'
    },
    {
      icon: 'HeartIcon',
      value: '8,932',
      label: 'Active Donors',
      description: 'Generous supporters making a difference'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-headline font-bold text-foreground mb-4">
            Your Donations Create Real Impact
          </h2>
          <p className="text-lg text-muted-foreground font-body max-w-3xl mx-auto">
            See the measurable difference your generosity makes in communities around the world
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {impactStats.map((stat, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-6 shadow-lg border border-border hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                  <Icon name={stat.icon as any} size={32} className="text-primary" variant="solid" />
                </div>
                <div className="text-4xl font-headline font-bold text-foreground mb-2">
                  {stat.value}
                </div>
                <div className="text-lg font-cta font-bold text-foreground mb-2">
                  {stat.label}
                </div>
                <p className="text-sm text-muted-foreground font-body">
                  {stat.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;